import { Injectable } from '@angular/core';

import {
	OrderByEnum,
	RequestPaginationInterface,
} from '@reach/interfaces/requests/request-pagination.interface';
import {
	SearchAITypeEnum,
	SearchNodeResponse,
	SearchParams,
	SearchResponse,
} from '@reach/interfaces/search/search-query.type';
import { SortKey } from '@reach/interfaces/search/sort-key.type';
import { BooleanEnum } from '@reach/interfaces/typescript/boolean-enum.type';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class SearchApiService extends BaseApiService {
	protected commonPath = ['search'];

	public async search<B extends BooleanEnum = BooleanEnum.NO>(
		query: SearchParams,
		pagination?: RequestPaginationInterface<SearchNodeResponse>,
		searchAIType?: SearchAITypeEnum,
		returnOnlyIds: B = BooleanEnum.NO as B
	): Promise<SearchResponse<B>> {
		const somethingQueried = (query.query ?? '').trim() !== '';

		const defaultSortBy = somethingQueried ? SortKey.RELEVANCE : SortKey.DATE;

		const page = pagination?.page ?? 0;
		const size = pagination?.size ?? 30;
		const sortBy = (pagination?.sortBy as SortKey | undefined) ?? defaultSortBy;
		const orderBy = pagination?.orderBy ?? OrderByEnum.DESC;

		const body = {
			searchParams: query,
			page: page,
			size: size,
			sortBy: sortBy,
			orderBy: orderBy,
			searchAIType,
			...(returnOnlyIds === BooleanEnum.YES ? { returnOnlyIds: BooleanEnum.YES } : {}),
		};

		return await this.http.post<SearchResponse<B>>(this.url(), body);
	}

	public async getAllIds(
		query: SearchParams,
		searchAIType?: SearchAITypeEnum
	): Promise<SearchResponse<BooleanEnum.YES>> {
		const body = {
			searchParams: query,
			searchAll: true,
			returnOnlyIds: BooleanEnum.YES,
			searchAIType,
		};

		return await this.http.post<SearchResponse<BooleanEnum.YES>>(this.url(), body);
	}
}
